import { Tag as AntTag, TagProps } from 'antd';

const Tag = (props: TagProps) => {
  return <AntTag {...props} className={`custom-tag ${props.className}`} />;
};
export default Tag;
